import { createFileRoute } from "@tanstack/react-router";

import LoginPage from "./-components/LoginPage";
import WithGoogleAuth from "@/components/WithGoogleAuth";
import { GoogleAuthProvider } from "@/providers/GoogleAuthProvider";

export const Route = createFileRoute("/_app/login/")({
  component: Login,
});

/**
 * Not a child of `_dashboard`: sign-in replaces the dashboard chrome with the
 * Google OAuth context it needs. `endpoint` is what keeps this route out of a
 * shared layout with `/register` and the other sign-up surfaces — they pass
 * `"register"`.
 */
function Login() {
  return (
    <WithGoogleAuth>
      <GoogleAuthProvider endpoint="login" flow="redirect">
        <LoginPage />
      </GoogleAuthProvider>
    </WithGoogleAuth>
  );
}
